var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79019 17.3838L4.45144 12.5026C4.28634 12.3166 4.05412 12.2038 3.80587 12.189C3.55762 12.1743 3.31367 12.2587 3.12769 12.4238C2.94171 12.5889 2.82892 12.8211 2.81416 13.0694C2.79939 13.3176 2.88384 13.5616 3.04894 13.7476L8.04894 19.3726C8.13382 19.4681 8.23732 19.5452 8.3531 19.5992C8.46887 19.6533 8.59447 19.6831 8.72218 19.6868C8.8499 19.6906 8.97703 19.6682 9.09577 19.621C9.21451 19.5739 9.32236 19.5029 9.41269 19.4126L22.5377 6.28755C22.7033 6.10983 22.7934 5.87478 22.7892 5.6319C22.7849 5.38902 22.6865 5.15729 22.5147 4.98553C22.3429 4.81376 22.1112 4.71537 21.8683 4.71108C21.6255 4.7068 21.3904 4.79695 21.2127 4.96255L8.79019 17.3838Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaw);
export default __webpack_public_path__ + "static/media/Daw.9089c5f826b7460076df79c348c4bab8.svg";
export { ForwardRef as ReactComponent };